// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","backButton":"backButton-3X8ad","backButton__wrapper":"backButton__wrapper-1MKBV","continueButton":"continueButton-3iilv"};